import React, { useEffect, useState } from "react";
import SingleEditItem from "./SingleEditItem";
import LoadingSpinner from "./../UI/LoadingSpinner";

const EditUserList = (props) => {
    const [list, setList] = useState(props.users);

    useEffect(() => {
        setList(props.users);
        // console.log("list", list);
    }, [props.users]);

    if (list.length > 0) {
        return (
            <div className='mb-2 h-full max-h-[100px] overflow-y-scroll'>
                {list.map((item, index) => {
                    return (
                        <SingleEditItem
                            key={item._id}
                            onEdit={props.onEdit}
                            onDelete={props.onDelete}
                            index={index}
                            id={item._id}
                            label={item.name}
                        />
                    );
                })}
            </div>
        );
    } else {
        return (
            <div className='mb-2 flex h-full  max-h-[100px] items-center justify-center overflow-y-scroll'>
                <LoadingSpinner />
            </div>
        );
    }
};

export default React.memo(EditUserList);
